<template>
	<div class="row full-height">
		<div class="col-12">
			<vue-plyr ref="plyr" class="video" :options="options" v-if="show_player">
				<video playsinline webkit-playsinline ref="player" id="player" />
			</vue-plyr>

			<q-card class="fit q-pa-md" v-if="!webinar_is_online && !show_player">
				<q-card-section>
					<div class="row q-col-gutter-sm text-grey-6">
						<div class="col-12 text-center text-weight-bold text-subtitle1">
							{{ $t('webinar_offline') }}
						</div>

						<div class="col-12 q-mt-md text-center">
							<img :src="`placeholders/webinar-waiting.gif`" class="test-placeholder" />
						</div>
					</div>
				</q-card-section>

				<q-card-section class="relative-position text-grey-6">
					<div class="row q-col-gutter-md text-center justify-center">
						<div class="col-sm-12 col-xl-6">
							{{ $t('your_webinar_will_start_soon_please_wait') }}
						</div>
					</div>
				</q-card-section>
			</q-card>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hls from 'hls.js'

export default {
	name: 'WebinarWowzaPlayer',

	props: ['activity'],

	data() {
		return {
			options: {
				autoplay: false,
			},
			show_player: false,
		}
	},

	computed: {
		...mapGetters({
			webinar_is_online: 'webinars/webinar_is_online',
		}),

		player() {
			return this.$refs.player
		},
	},

	watch: {
		webinar_is_online: function () {
			if (this.webinar_is_online) {
				setTimeout(() => {
					const hls = new Hls()
					hls.loadSource(this.activity.webcast_player_hls_playback_url)
					hls.attachMedia(this.player)
				}, 5000)
				this.show_player = true
			}
		},
	},

	created() {
		this.$emit('startWebinar', this.activity)
	},

	beforeDestroy() {
		this.$mitt.emit('setUserOfflineFirebase', this.activity)
	},
}
</script>

<style lang="scss" scoped>
.test-placeholder {
	width: auto;
	height: 32vh;
}
</style>
